import React from 'react'
import { useTranslation } from 'react-i18next'

function Location() {
  const { t } = useTranslation()

  const directionsUrl =
    'https://www.google.com/maps/dir/?api=1&destination=1629+W+University+Dr+Denton+TX+76201'

  const days = [
    { key: 'Mon' },
    { key: 'Tue' },
    { key: 'Wed' },
    { key: 'Thu' },
    { key: 'Fri' },
    { key: 'Sat' },
    { key: 'Sun' }
  ]

  return (
    <section
      id="location"
      className="section section-warm location"
      aria-labelledby="location-heading"
    >
      <div className="container-wide location-grid">
        <div className="location-text">
          <h2 id="location-heading">{t('location.heading')}</h2>
          <p className="location-address">{t('location.address')}</p>
          <p className="location-note">{t('location.locationNote')}</p>

          <h3 className="hours-heading">{t('location.hoursHeading')}</h3>
          <dl className="hours-list">
            {days.map(({ key }) => (
              <React.Fragment key={key}>
                <dt className="hours-day">{t(`location.hours${key}`)}</dt>
                <dd className="hours-time">{t(`location.hours${key}Time`)}</dd>
              </React.Fragment>
            ))}
          </dl>

          <div className="location-cta-row">
            <a href="tel:+14694917604" className="btn-primary">
              {t('location.callCta')}
            </a>
            <a
              href={directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              {t('location.directionsCta')}
            </a>
          </div>
        </div>

        <div className="location-image-wrap">
          <img
            src="/images/truck.jpg"
            alt={t('location.truckAlt')}
            className="location-image"
            width="1200"
            height="900"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  )
}

export default Location
